const WHISKYMOFO_ENABLED = process.env.GATSBY_ENABLE_WHISKYMOFO === "true";

export const SPIRIT_KEYWORDS = [
  "whisky",
  "gin",
  "vodka",
  "brandy",
  "rum",
  "tequila",
  "cognac",
  "mezcal",
  "agave",
  "spirits",
  "liqueur",
  "cocktail",
];

export const hasSpiritsInPath = (pathname?: string): boolean => {
  return SPIRIT_KEYWORDS.some((keyword) =>
    pathname?.toLowerCase().includes(keyword.toLowerCase())
  );
};

export const isVinoArticlePage = (pathname?: string): boolean => {
  return pathname?.toLowerCase().includes("/vino-articles/") || false;
};

export const isWhiskymofoSignupPage = (pathname?: string): boolean => {
  return (
    (WHISKYMOFO_ENABLED &&
      pathname?.toLowerCase().includes("/whiskymofo-signup")) ||
    false
  );
};

export const isWhiskymofoDealsPage = (pathname?: string): boolean => {
  return (
    (WHISKYMOFO_ENABLED && pathname?.toLowerCase().includes("/whiskymofo")) ||
    false
  );
};
